import { render, staticRenderFns } from "./form_input.vue?vue&type=template&id=24b24ae0"
import script from "./form_input.vue?vue&type=script&lang=js"
export * from "./form_input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports